import { UploadDocument } from '@/components/my-documents-components/upload-document-component';
import store from '@/store';
import { RouteConfig } from 'vue-router';

export const documentsRoutes: RouteConfig[] = [
  {
    name: 'uploadDocument',
    path: '/upload-document/:step',
    component: UploadDocument,
    meta: {
      transitionIn: 'slide-up',
      transitionMode: 'in-out',
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('setPreviousRoute', from);
      next();
    },
  },
  {
    name: 'uploadDocumentDefault',
    path: '/upload-document',
    redirect: {
      name: 'uploadDocument',
      params: {
        step: '1',
      },
    },
  },
];
